<template>
  <div>
  <el-form class="edit-profile-form">
    <div class="form-grouup">
      <label class="col-lg-3 control-label"></label>
      <el-form-item class="col-lg-9">
        <croppa
          ref="croppa"
          v-model="myCroppa"
          :width="256"
          :height="256"
          :canvas-color="'transparent'"
          :placeholder="'Choose an avatar'"
          :show-loading="true"
          :initial-image="avatar"
          :accept="'image/*'">
        </croppa>
      </el-form-item>
    </div>
    <div class="form-grouup">
      <label class="col-lg-3 control-label">Email</label>
      <el-form-item class="col-lg-9">
        <el-input placeholder="Email" type="email" v-model="email"   ></el-input>
      </el-form-item>
    </div>
    <div class="form-grouup">
      <label class="col-lg-3 control-label">First name</label>
      <el-form-item class="col-lg-9">
        <el-input placeholder="First name" v-model="firstname"  ></el-input>
      </el-form-item>
    </div>
    <div class="form-grouup">
       <label class="col-lg-3 control-label">Last name</label>
        <el-form-item class="col-lg-9">
        <el-input placeholder="Last name" v-model="lastname"></el-input>
    </el-form-item>
    </div>
    <el-button class="update-btn" @click="handleClickUpdate()" :disabled="isDisabled">Update</el-button>
  </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'EditProfileForm',
  props: {
    user: {
      type: Object,
    },
  },
  created() {
    this.id = this.$store.state.user.me.id;
    this.email = this.$store.state.user.me.email;
    this.lastname = this.$store.state.user.me.last_name;
    this.firstname = this.$store.state.user.me.first_name;
    this.avatar = this.$store.state.user.me.avatar;
  },
  data: () => ({
    // ...mapState('user', ['']),
    id: null,
    email: null,
    lastname: null,
    firstname: null,
    avatar: null,
    myCroppa: {},
    avatar_blob: null,
  }),
  computed: {
    isDisabled() {
      let disable = true;
      if (this.email.trim() !== '' && this.lastname.trim() !== '' && this.firstname.trim() !== '') {
        disable = false;
      }
      return disable;
    },
    ...mapState('user', ['updatingProfileSuccess', 'updatingProfileFailed']),
  },
  watch: {
    updatingProfileSuccess(newValue) {
      if (newValue === true) {
        this.$store.dispatch('toast/success', 'Your profile has been updated.');
      }
    },
    updatingProfileFailed(newValue) {
      if (newValue) {
        this.$store.dispatch('toast/error', 'Your profile could not be updated.');
      }
    },
  },
  methods: {
    handleClickUpdate() {
      this.myCroppa.generateBlob(
        blob => {
          const form = new FormData();
          form.append('id', this.id);
          form.append('email', this.email);
          form.append('last_name', this.lastname);
          form.append('first_name', this.firstname);
          form.append('avatar', blob, 'avatar.jpg');
          const payload = { id: this.id, form };
          this.$store.dispatch('user/updateUserProfile', payload);
        },
        'image/jpeg',
        0.7,
      );
    },
  },
};
</script>

<style lang="scss" >
@import '../../assets/style/_variables_live.scss';

.update-btn {
  color: white;
  width: 100%;
  background: $colony-primary;
  border-color: $colony-primary;
  border-radius: 0;
}
.feedback {
  padding: 5px;
}

.croppa-container {
  text-align: center;
  background-color: white;
  width: 256px;
  height: 256px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// EditProfileForm.vue?03afbd4c